import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card bg-white border-0 rounded-3 mb-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("div", { class: "card-body p-4" }, [
      _createElementVNode("div", { class: "d-sm-flex justify-content-between mb-4" }, [
        _createElementVNode("h3", { class: "mb-0" }, "Write Feedback Here:"),
        _createElementVNode("ul", { class: "ps-0 mb-0 list-unstyled d-flex gap-2 justify-content-center ratings" }, [
          _createElementVNode("li", { class: "rating" }, [
            _createElementVNode("i", { class: "ri-star-fill fs-20" })
          ]),
          _createElementVNode("li", { class: "rating" }, [
            _createElementVNode("i", { class: "ri-star-fill fs-20" })
          ]),
          _createElementVNode("li", { class: "rating" }, [
            _createElementVNode("i", { class: "ri-star-fill fs-20" })
          ]),
          _createElementVNode("li", { class: "rating" }, [
            _createElementVNode("i", { class: "ri-star-fill fs-20" })
          ]),
          _createElementVNode("li", { class: "rating" }, [
            _createElementVNode("i", { class: "ri-star-fill fs-20" })
          ])
        ])
      ]),
      _createElementVNode("form", null, [
        _createElementVNode("div", { class: "row" }, [
          _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("div", { class: "form-group mb-4" }, [
              _createElementVNode("label", { class: "label text-secondary" }, "Your Name"),
              _createElementVNode("input", {
                type: "text",
                class: "form-control h-55 text-dark",
                placeholder: "Your Name"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("div", { class: "form-group mb-4" }, [
              _createElementVNode("label", { class: "label text-secondary" }, "Your Email"),
              _createElementVNode("input", {
                type: "email",
                class: "form-control h-55 text-dark",
                placeholder: "Your Email"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("div", { class: "form-group mb-4" }, [
              _createElementVNode("label", { class: "label text-secondary" }, "Your Phone No"),
              _createElementVNode("input", {
                type: "number",
                class: "form-control h-55 text-dark",
                placeholder: "Your Phone No"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-lg-6" }, [
            _createElementVNode("div", { class: "form-group mb-4" }, [
              _createElementVNode("label", { class: "label text-secondary" }, "Your Subject"),
              _createElementVNode("input", {
                type: "email",
                class: "form-control h-55 text-dark",
                placeholder: "Your Subject"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-lg-12" }, [
            _createElementVNode("div", { class: "form-group mb-4" }, [
              _createElementVNode("label", { class: "label text-secondary" }, "Write Comment"),
              _createElementVNode("textarea", {
                class: "form-control",
                placeholder: "Write Comment",
                cols: "30",
                rows: "10",
                "data-gramm": "false",
                "wt-ignore-input": "true"
              })
            ])
          ]),
          _createElementVNode("div", { class: "col-lg-12" }, [
            _createElementVNode("div", { class: "form-group mb-0" }, [
              _createElementVNode("button", {
                type: "submit",
                class: "btn btn-primary text-white fw-semibold py-3 px-5"
              }, " Submit ")
            ])
          ])
        ])
      ])
    ], -1)
  ])))
}